<div class="header">
  <span>{{ data.title | translate | uppercase }}</span>
</div>
<div class="section subtitle" *ngIf="data.subtitle">
  <span>{{ data.subtitle | translate }}</span>
</div>
<div class="section actions">
  <button mat-flat-button color="secondary" type="button" (click)="close()">
    {{ data.cancel | translate }}
  </button>
  <button mat-flat-button color="primary" type="button" (click)="validate()">
    {{ data.validate | translate }}
  </button>
</div>
